import { FormValues } from '../../../components/AdForm/Store/reducers/formReducer/types'
import { RegistrationResponse } from '../registrationApi/types'
import { formatters } from '../registrationApi/formatters'
import { getChannelFromUrl, getFbclid } from '../shared/api'

export const submitAdFormRegistration = async (
    data: FormValues,
    offerId: string,
    registerToken?: string
): Promise<RegistrationResponse> => {
    const csrfToken = document.querySelector<HTMLMetaElement>(
        'meta[name="csrf-token"]'
    )?.content
    if (!csrfToken) {
        throw new Error('CSRF token not found')
    }

    try {
        const formattedData = formatters(data)
        const channel = getChannelFromUrl(null)
        const fbclid = getFbclid()
        const url = new URL('/apply', window.location.origin)
        if (channel) url.searchParams.set('channel', channel)

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify({
                user: formattedData,
                application: { offer_id: offerId },
                register_token: registerToken,
                fbclid,
            }),
        })

        if (!response.ok) {
            const contentType = response.headers.get('content-type') || ''
            if (contentType.includes('text/plain')) {
                const errorMessage = await response.text()
                return Promise.reject(new Error(errorMessage))
            }
            return Promise.reject(
                new Error(`HTTP error! status: ${response.status}`)
            )
        }

        const responseData = await response.json()

        if (responseData.status === 'success' && responseData.location) {
            window.location.href = responseData.location
        }
        return responseData
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Registration failed: ${error.message}`)
        }
        throw new Error('Registration failed: Unknown error')
    }
}
